import React from "react";
import { BorderOutlined, MinusSquareFilled } from "@ant-design/icons";
import MonthMapTable from "./MonthMapTable";
import "../styles/components/monthly-heat-map.scss";

class MonthlyHeatMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      innerWidth: null,
    };
  }

  throttledHandleWindowResize = () => {
    this.setState(() => ({ innerWidth: window.innerWidth }));
  };

  componentDidMount() {
    this.setState(() => ({ innerWidth: window.innerWidth }));
    window.addEventListener("resize", this.throttledHandleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.throttledHandleWindowResize);
  }

  getMonthsToRender = () => {
    const temp = [5, 4, 3, 2, 1, 0];
    let months = [5, 4, 3, 2, 1, 0];
    const bigScreenlimit = 1450;
    const smallScreenLimit = 850;
    const tableWidth = 150;
    if (
      this.state.innerWidth > smallScreenLimit &&
      this.state.innerWidth < bigScreenlimit
    ) {
      months = temp.splice(
        (bigScreenlimit - this.state.innerWidth) / tableWidth + 1,
        temp.length - (bigScreenlimit - this.state.innerWidth) / tableWidth
      );
    } else if (this.state.innerWidth < smallScreenLimit) {
      months = temp.splice(2, 4);
      months = months.splice(
        (smallScreenLimit - this.state.innerWidth) / tableWidth,
        months.length -
          (smallScreenLimit - this.state.innerWidth) / tableWidth +
          1
      );
    }
    return months;
  };

  render() {
    return (
      <div className="monthly-heat-map">
        <div className="monthly-heat-map--calendar">
          {this.getMonthsToRender().map((el, index) => (
            <MonthMapTable
              monthBefore={el}
              data={this.props.data}
              checkId={this.props.checkId}
              key={`monthly-heat-map-${index}`}
              onDateClicked={this.props.onDateClicked}
              activePlanHistoryPeriod={this.props.activePlanHistoryPeriod}
              activePlanName={this.props.activePlanName}
              isShare={this.props.isShare}
            />
          ))}
        </div>

        <div className="monthly-heat-map--legend">
          <div className="label disabled">
            <BorderOutlined />
            <span>No data</span>
          </div>
          <div className="label green">
            <MinusSquareFilled />
            <span>No downtime</span>
          </div>
          <div className="label yellow">
            <MinusSquareFilled />
            <span>{"< 15m downtime"}</span>
          </div>
          <div className="label red">
            <MinusSquareFilled />
            <span>{"> 15m downtime"}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default MonthlyHeatMap;
